// import React from 'react';
// import './Health.css';
// import AllIntroTemplate from "../../components/AllIntroTemplate/AllIntroTemplate.js";

// import ContentModel from "../../components/ContentModel/ContentModel.js";
// import { getStoredData } from "../../json/fetchData.js";

// const Health = () => {
//   const totalData = getStoredData();
//   const data = totalData ? totalData["24"] : {};
//   return (
//     <div>
//       <AllIntroTemplate image={data.Image} title={data.Title} page={totalData ? totalData["0"] : {}}/>
//       <ContentModel data={totalData ? totalData["24"] : {}}/>
//     </div>
//   );
// };

// export default Health;


import React, { Suspense, lazy } from 'react';
import './Health.css';
import { getStoredData } from "../../json/fetchData.js";

// Lazy load components
const AllIntroTemplate = lazy(() => import("../../components/AllIntroTemplate/AllIntroTemplate.js"));
const ContentModel = lazy(() => import("../../components/ContentModel/ContentModel.js"));

const Health = () => {
  const totalData = getStoredData();
  const data = totalData ? totalData["24"] : {};

  return (
    <div>
      <Suspense fallback={<p>Loading intro...</p>}>
        <AllIntroTemplate 
          image={data.Image} 
          title={data.Title} 
          page={totalData ? totalData["0"] : {}} 
        />
      </Suspense>

      <Suspense fallback={<p>Loading content...</p>}>
        <ContentModel data={totalData ? totalData["24"] : {}} />
      </Suspense>
    </div>
  );
};

export default Health;
